import { render } from "./StatusPicker.vue?vue&type=template&id=707cdcc3&scoped=true"
import script from "./StatusPicker.vue?vue&type=script&lang=js"
export * from "./StatusPicker.vue?vue&type=script&lang=js"

import "./StatusPicker.vue?vue&type=style&index=0&id=707cdcc3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-707cdcc3"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QMenu,QList,QItem,QItemSection,QIcon});qInstall(script, 'directives', {ClosePopup});
